import { lazy } from 'react';

const CharityVettingHACCPRoute = lazy(
  () =>
    import(/* webpackChunkName: "CharityVettingHACCP" */ '../components/steps/HACCP-step/HACCP'),
);

export default CharityVettingHACCPRoute;
